import colors from 'vuetify/es5/util/colors'
var themes = {
  light: {
    primary: '#d1c4e1',
    secondary: '#f2f2df',
    accent: colors.blue.accent1,
    error: colors.red.accent2,
    info: colors.blue,
    success: colors.green,
    warning: colors.amber
  },
  dark: {
    primary: colors.blue.darken2,
    secondary: colors.grey.lighten2,
    accent: colors.blue.accent1,
    error: colors.red.accent2,
    info: colors.blue,
    success: colors.green,
    warning: colors.amber
  }
}

var contain = false
var showLogoLogin = true

var headerTextDark = false

const background = '/assets/imgs/background.svg'
const logo = '/assets/imgs/logo.svg'
const logoHeader = '/assets/imgs/logo.svg'

export default {
  dark: false,
  options: {
    customProperties: true,
    dense: false,
    toolbar: { color: themes.light.primary, dark: headerTextDark }
  },
  background,
  logo,
  logoHeader,
  viewOptions: {
    Home: {
      backgroundContain: contain
    },
    Login: {
      showLogoLogin: showLogoLogin
    }
  },
  themes: themes
}
